<template>
    <div class="title-header-container">
        {{ title }}
    </div>
</template>

<script>
    export default {
        name: "TitleHeader",
        props: {
            title: {
                type: String,
                default: ""
            }
        }
    }
</script>

<style lang="scss" scoped>
    .title-header-container {
        padding-left: 13px;
        height: 36px;
        line-height: 36px;
        background: var(--theme-header);
        color: var(--theme-label);
    }
</style>

